import { topicParticle } from './korean';

/**
 * 서버에 맡겨 나중에 끝나는 일(앱 `waitQueueStore`). 드라이버가 버튼·저장 뒤 새로 올라간 것을
 * 돌려준다(`driver/src/waitQueue.ts`). 턴은 그 끝을 기다리지 않는다 — 몇 분이 걸릴 수 있다.
 * 끝났는지는 패널이 지켜보고 그때 알린다.
 */
export type QueuedJob = { key: string; title: string; startedAt: number };

type WithQueued = { queued?: QueuedJob[] };

/**
 * 한 턴 동안 세션의 `commit`·`operate` 가 돌려준 대기열 일을 모은다.
 *
 * 저장 경로가 여러 갈래라 갈래마다 챙기면 한 곳은 빠진다. 세션 한 곳에서 거둔다. 다른 메서드는
 * 원래 객체에 묶어 그대로 넘긴다 — 세션은 `this` 에 미뤄 둔 칸 같은 상태를 들고 있다.
 */
export function collectQueued<T extends object>(session: T, into: QueuedJob[]): T {
  return new Proxy(session, {
    get(target, prop) {
      const value = Reflect.get(target, prop, target);
      if (typeof value !== 'function') return value;
      if (prop !== 'commit' && prop !== 'operate') return value.bind(target);
      return async (...args: unknown[]) => {
        const result = await value.apply(target, args) as WithQueued | undefined;
        if (result?.queued?.length) into.push(...result.queued);
        return result;
      };
    },
  });
}

/** 답 끝에 붙는 말. 사람은 일이 끝난 줄 알면 안 된다 — 서버가 아직 하고 있다. */
export function queuedNote(jobs: QueuedJob[]): string {
  const titles = Array.from(new Set(jobs.map((job) => job.title))).join(', ');
  return `${topicParticle(titles)} 서버에서 이어서 처리합니다. 끝나면 이 창에서 알려 드리겠습니다.`;
}
